import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { User } from '@models';

export const UserActions = createActionGroup({
  source: 'User',
  events: {
    'Load Current': emptyProps(),
    'Load Current Succeeded': props<{ user: User }>(),
    'Load Current Failed': props<{ error: string }>(),
    'Set Current': props<{ user: User | null }>(),
    Cleared: emptyProps(),
  },
});
